import { TrainingActionTypes } from '.';
import { Action } from '@ngrx/store';
import { TrainingCategory, AppliedTraining, TrainingContent, TrainingQuiz, TrainingQuizAnswerPayload, TrainingProgress } from '../../model/TrainingModel';

export class TrainingListAction implements Action {
    public type = TrainingActionTypes.TRAINING_LIST;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor() { }
}

export class TrainingListClientAction implements Action {
    public type = TrainingActionTypes.TRAINING_LIST_CLIENT;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { clientId: number }) { }
}

export class TrainingListAppliedAction implements Action {
    public type = TrainingActionTypes.TRAINING_LIST_APPLIED;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { userId: number }) { }
}

export class TrainingStatusUpdateAction implements Action {
    public type = TrainingActionTypes.SAVE_STATUS;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { data: AppliedTraining }) { }
}

export class TrainingClearAction implements Action {
    public type = TrainingActionTypes.TRAINING_CLEAR;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor() { }
}

export class TrainingListContentAction implements Action {
    public type = TrainingActionTypes.LOAD_CONTENT;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { trainingId: number }) { }
}

export class TrainingListQuizAction implements Action {
    public type = TrainingActionTypes.LOAD_QUIZ;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { clientId: number, quizList: Array<number> }) { }
}

export class TrainingSaveQuizAction implements Action {
    public type = TrainingActionTypes.SAVE_QUIZ;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { data: TrainingQuizAnswerPayload }) { }
}

export class TrainingSaveProgressAction implements Action {
    public type = TrainingActionTypes.SAVE_PROGRESS;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { data: TrainingProgress }) { }
}

export class TrainingGetProgressAction implements Action {
    public type = TrainingActionTypes.GET_PROGRESS;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor(public payload: { clienteId: number, alunoId: number, cursoId: number }) { }
}

export class TrainingClearErrorsAction implements Action {
    public type = TrainingActionTypes.TRAINING_CLEAR_ERRORS;
    public categories: Array<TrainingCategory>;
    public appliedTrainings: Array<AppliedTraining>;
    public content: Array<TrainingContent>;
    public quiz: Array<TrainingQuiz>;
    public progress: Array<TrainingProgress>;
    public errorPayload: any;
    constructor() { }
}

export type TrainingActions = TrainingListAction | TrainingListClientAction | TrainingListAppliedAction | TrainingListContentAction | TrainingSaveQuizAction | TrainingSaveProgressAction | TrainingGetProgressAction | TrainingSaveProgressAction | TrainingClearErrorsAction;


// WEBPACK FOOTER //
// ./src/store/action/TrainingActions.ts